import { Quote, Star } from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";
import { SITE } from "../config/site";

// Genuine Google reviews supplied by the store owner — do not add or alter.
const REVIEWS = [
  {
    date: "23 Oct 2024",
    text: "Perfect English. Lovely persons. Quick service and good explanations. I am from Germany. Prices seem fair even for foreigners. Will come back when I need more.",
    meta: "Visitor from Germany",
  },
  {
    date: "29 Nov 2022",
    text: "Awesome experience of shopping and they have varieties of shoes, slippers and clothes. Shopping is worth here.",
    meta: "Local shopper",
  },
];

export const Reviews = () => (
  <section id="reviews" className="py-16 sm:py-24 lg:py-32 relative overflow-hidden">
    <div
      className="absolute -top-32 left-1/2 -translate-x-1/2 w-[640px] h-[640px] rounded-full bg-gold/[0.05] blur-3xl"
      aria-hidden="true"
    />
    <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 relative">
      <Reveal className="text-center max-w-2xl mx-auto">
        <Eyebrow>What customers say on Google</Eyebrow>
        <h2 className="mt-4 font-display text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tight text-cream text-balance">
          Trusted by regulars — and travellers.
        </h2>
      </Reveal>

      <div className="mt-12 grid md:grid-cols-2 gap-6 lg:gap-8">
        {REVIEWS.map((r, i) => (
          <Reveal key={r.date} delay={i * 0.12}>
            <blockquote
              data-testid={`review-card-${i + 1}`}
              className="h-full flex flex-col bg-charcoal-card border border-white/10 rounded-3xl p-7 sm:p-9 hover:border-gold/40 transition-colors duration-500"
            >
              <Quote size={28} className="text-gold/70" aria-hidden="true" />
              <p className="mt-5 font-display text-lg sm:text-xl text-cream/90 leading-relaxed flex-1">
                “{r.text}”
              </p>
              <footer className="mt-7 pt-5 border-t border-white/10 flex items-center justify-between gap-4">
                <span className="text-sm text-cream/55">{r.meta}</span>
                <span className="inline-flex items-center gap-2 font-mono text-[10px] uppercase tracking-[0.25em] text-gold">
                  <GoogleG /> Google · {r.date}
                </span>
              </footer>
            </blockquote>
          </Reveal>
        ))}
      </div>

      <Reveal delay={0.2} className="mt-10 flex flex-wrap items-center justify-center gap-4">
        <a
          href={SITE.reviewUrl}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="write-review-button"
          className="inline-flex items-center gap-2.5 bg-gold text-charcoal font-semibold rounded-full px-7 py-3.5 hover:bg-gold-hover transition-all duration-300 hover:-translate-y-0.5 shadow-[0_10px_40px_-10px_rgba(212,175,55,0.5)]"
        >
          <Star size={17} fill="currentColor" /> Happy with us? Leave a Google Review
        </a>
        <a
          href={SITE.mapsUrl}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="reviews-google-link"
          className="inline-flex items-center gap-2 border border-cream/25 text-cream text-sm rounded-full px-6 py-3 hover:border-gold hover:text-gold transition-colors duration-300"
        >
          <GoogleG /> See us on Google Maps
        </a>
      </Reveal>
    </div>
  </section>
);

const GoogleG = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" aria-hidden="true">
    <path fill="#EA4335" d="M12 10.2v3.9h5.5c-.2 1.3-1.6 3.8-5.5 3.8-3.3 0-6-2.7-6-6.1s2.7-6.1 6-6.1c1.9 0 3.1.8 3.9 1.5l2.6-2.5C16.9 3.1 14.7 2 12 2 6.5 2 2 6.5 2 12s4.5 10 10 10c5.8 0 9.6-4.1 9.6-9.8 0-.7-.1-1.2-.2-1.7H12z" />
  </svg>
);
